module.exports={account_link_complete_message:"Le lien au compte Nexon est terminé."};